export const getDstOffsetHours = (port, localTimeStart, localTimeEnd) => {
    let offset = 0;

    if (port) {
        port.timeZoneList.forEach((tz) => {
            const _hasDaylightSaving = hasDaylightSaving(tz);
            const hasDstStart =
                _hasDaylightSaving && tz.year === localTimeStart.getFullYear() && tz.dstStartLocalTime !== null && tz.dstEndLocalTime !== null;
            const hasDstEnd =
                _hasDaylightSaving && tz.year === localTimeEnd.getFullYear() && tz.dstStartLocalTime !== null && tz.dstEndLocalTime !== null;

            if (hasDstStart && hasDstEnd) {
                const dstStart = new Date(tz.dstStartLocalTime);
                const dstEnd = new Date(tz.dstEndLocalTime);

                const isStartInDstRange = isInDstRange(dstStart, localTimeStart, localTimeEnd);
                const isEndInDstRange = isInDstRange(dstEnd, localTimeStart, localTimeEnd);

                if (isStartInDstRange || isEndInDstRange) {
                    offset = tz.utcOffset - tz.utcOffsetDst;

                    if (isNorthernHemisphere(tz)) {
                        const isLocalTimeInNorthernHemisphereDstStart = isLocalTimeInNorthernHemisphereDst(tz, localTimeStart);
                        const isLocalTimeInNorthernHemisphereDstEnd = isLocalTimeInNorthernHemisphereDst(tz, localTimeEnd);

                        if (
                            (!isLocalTimeInNorthernHemisphereDstStart && !isLocalTimeInNorthernHemisphereDstEnd) ||
                            (isLocalTimeInNorthernHemisphereDstStart && !isLocalTimeInNorthernHemisphereDstEnd)
                        ) {
                            offset *= -1;
                        }
                    } else {
                        const isLocalTimeInSouthernHemisphereDstStart = isLocalTimeInSouthernHemisphereDst(tz, localTimeStart);
                        const isLocalTimeInSouthernHemisphereDstEnd = isLocalTimeInSouthernHemisphereDst(tz, localTimeEnd);

                        if (
                            (!isLocalTimeInSouthernHemisphereDstStart && !isLocalTimeInSouthernHemisphereDstEnd) ||
                            (isLocalTimeInSouthernHemisphereDstStart && !isLocalTimeInSouthernHemisphereDstEnd)
                        ) {
                            offset *= -1;
                        }
                    }
                }
            }
        });
    }

    return offset;
};

const hasDaylightSaving = (timeZone) => {
    return timeZone.dstStartLocalTime !== null && timeZone.dstEndLocalTime !== null;
};

const isInDstRange = (date, rangeStart, rangeEnd) => {
    return date >= rangeStart && date <= rangeEnd;
};

const isNorthernHemisphere = (timeZone) => {
    return new Date(timeZone.dstStartLocalTime) < new Date(timeZone.dstEndLocalTime);
};

const isLocalTimeInNorthernHemisphereDst = (timeZone, localTime) => {
    return hasDaylightSaving(timeZone) && localTime >= new Date(timeZone.dstStartLocalTime) && localTime < new Date(timeZone.dstEndLocalTime);
};

const isLocalTimeInSouthernHemisphereDst = (timeZone, localTime) => {
    return hasDaylightSaving(timeZone) && (localTime >= new Date(timeZone.dstStartLocalTime) || localTime < new Date(timeZone.dstEndLocalTime));
};
